import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=658e9fbf&scoped=true&"
import script from "./InfoModal.vue?vue&type=script&lang=ts&"
export * from "./InfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./InfoModal.vue?vue&type=style&index=0&id=658e9fbf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658e9fbf",
  null
  
)

export default component.exports